module.exports = __webpack_public_path__ + "static/media/orinocco100.c802d979.jpg";